import { supabase } from '@/core/database/supabase';
import type { QaStats } from '../types/construction-qa.types';

export const ConstructionQaStatsService = {
  async getQaStats(companyId: string, projectId?: string): Promise<QaStats> {
    let query = supabase
      .from('construction_qa_inspections')
      .select('status_code, result_code, score')
      .eq('company_id', companyId);
      
    if (projectId) query = query.eq('project_id', projectId);

    const { data, error } = await query;
    if (error) throw error;

    const ncrQuery = supabase
      .from('construction_ncrs')
      .select('id', { count: 'exact' })
      .eq('company_id', companyId)
      .neq('status_code', 'closed');
      
    if (projectId) ncrQuery.eq('project_id', projectId);
    const { count: activeNcrCount } = await ncrQuery;

    const inspections = data || [];
    const passed = inspections.filter(i => i.result_code === 'pass').length;
    const failed = inspections.filter(i => i.result_code === 'fail').length;
    const pending = inspections.filter(i => i.status_code === 'submitted').length;
    const avgScore = inspections.length > 0 ? inspections.reduce((sum, i) => sum + (i.score || 0), 0) / inspections.length : 0;

    return {
      totalInspections: inspections.length,
      passedCount: passed,
      failedCount: failed,
      pendingReviewCount: pending,
      avgScore,
      activeNcrCount: activeNcrCount || 0,
    };
  }
};
